import { useEffect, useState } from "react";
import ToolBar from "../../../components/ToolBar";
import CreateButton from "../../../components/ToolBar/Buttons/CreateButton";
import RecordPerPage from "../../../components/ToolBar/Dropdown/RecordPerPage";
import ContentBox from "../../../components/ContentBox/ContentBox";
import Listing from "./components/Listing/Listing";
import {
  setPerPage,
  details,
  setDetails,
  deleteRecord,
  fetchList,
  fetchInterestAssessmentDetails,
  fetchSkillAssessmentDetails,
  fetchAssessmentResultDetails,
  setAssessmentResultId,
  setChangePasswordDetails,
  fetchAllIndustryExamDetails,
  setAllExamDetails,
} from "./utils/slice";
import DeleteModal from "../../../components/Modals/DeleteModal";
import ViewDrawer from "./components/ViewDrawer";
import AddComponent from "./components/Form/AddComponent";
import InviteComponent from "./components/Form/InviteComponent";
import EditComponent from "./components/Form/EditComponent";
import { UserBreadcrumb } from "../../../config/BreadcrumbConfig";
import { CONSTANT, CUSTOMER_ROLE } from "../../../config/Constant";
import { toUpperCaseWithUnderscore } from "../../../utils/commonFunctions";
import { useAppDispatch, useAppSelector } from "../../../utils/hooks/hooks";
import ViewInterestAssessmentDrawer from "./components/ViewDrawerInterestAssessment";
import ViewSkillAssessmentDrawer from "./components/ViewDrawerSkillAssementResult";
import ChangePasswordDrawer from "./components/Form/ChangePassword";
import {
  fetchCertificationsList,
  fetchEducationLevelsList,
  setAssessmentResultLoading,
  setEditLoading,
  setViewLoading,
} from "../../../store/CommonSlice";
import ViewAssessmentResultDrawer from "./components/ViewDrawerAssessmentResult";
import ImportComponent from "./components/Form/ImportComponent";
import ViewAllExamDetails from "./components/ViewAllExamDetails";

const moduleInfo = {
  title: "User",
  permissionKeyPrefix: toUpperCaseWithUnderscore("User"),
};

/**
 * Renders the User Management component.
 *
 * @return {ReactElement} The rendered User Management component.
 */
const UserManagement: React.FC<any> = () => {
  const dispatch = useAppDispatch();
  const { perPage } = useAppSelector((state) => state.user);

  const { userDetail } = useAppSelector((state) => state.auth);
  const [isCreateVisible, setIsCreateVisible] = useState(false);
  const [isInviteVisible, setIsInviteVisible] = useState(false);
  const [isImportVisible, setIsImportVisible] = useState(false);
  const [isChangePasswordVisible, setIsChangePasswordVisible] = useState(false);
  const [editDrawer, setEditDrawer] = useState(false);
  const [viewDrawer, setViewDrawer] = useState(false);
  const [viewAssessmentResultDrawer, setViewAssessmentResultDrawer] =
    useState(false);
  const [viewInterestAssessmentDrawer, setViewInterestAssessmentDrawer] =
    useState(false);
  const [viewSkillAssessmentDrawer, setViewSkillAssessmentDrawer] = useState(false);
  const [viewAllExamDrawer, setViewAllExamDrawer] = useState(false);
  const [viewChangePassword, setViewChangePassword] = useState(false);
  const [deleteValue, setDeleteValue] = useState<any>();
  useEffect(() => {
    dispatch(fetchList()).catch((error: any) => error);
  }, []);

  const getDetails = (data: any, type: string) => {
    if (type === CONSTANT.DRAWER_TYPE.VIEW) {
      dispatch(setViewLoading([true, data.id]));
    } else {
      dispatch(setEditLoading([true, data.id]));
    }
    dispatch(details(data.id))
      .then(() => {
        if (type === CONSTANT.DRAWER_TYPE.VIEW) {
          setViewDrawer(true);
          dispatch(setViewLoading([false, data.id]));
        }
        if (type === CONSTANT.DRAWER_TYPE.EDIT) {
          setEditDrawer(true);
          dispatch(setEditLoading([false, data.id]));
        }
      })
      .catch((error: any) => error);
  };

  const getAssessmentResultDetails = (data: any, type: string) => {
    const resultName = "View Career Compass Results";
    if (type === CONSTANT.DRAWER_TYPE.VIEW) {
      dispatch(setAssessmentResultLoading([true, data.skill_id, resultName]));
    }
    dispatch(fetchAssessmentResultDetails(data.skill_id))
      .then(() => {
        if (type === CONSTANT.DRAWER_TYPE.VIEW) {
          setViewAssessmentResultDrawer(true);
          dispatch(setAssessmentResultLoading([false, data.skill_id, resultName]));
        }
      })
      .catch((error: any) => error);

    dispatch(setAssessmentResultId(data.id));
  };

  const getInterestAssessmentDetails = (data: any, type: string) => {
    console.log('data', data);
    const resultName = "View Interest Discovery Results";
    if (type === CONSTANT.DRAWER_TYPE.VIEW) {
      dispatch(setAssessmentResultLoading([true, data?.exam_id, resultName]));
    }
    dispatch(fetchInterestAssessmentDetails(data?.exam_id))
      .then(() => {
        if (type === CONSTANT.DRAWER_TYPE.VIEW) {
          setViewInterestAssessmentDrawer(true);
          dispatch(setAssessmentResultLoading([false, data.exam_id, resultName]));
        }
      })
      .catch((error: any) => error);
  };

  const getSkillAssessmentDetails = (data: any, type: string) => {
    console.log('data', data);

    const resultName = "View Skill Portrait Results";
    if (type === CONSTANT.DRAWER_TYPE.VIEW) {
      dispatch(setAssessmentResultLoading([true, data.skill_id, resultName]));
    }
    dispatch(fetchSkillAssessmentDetails(data?.skill_id))
      .then(() => {
        if (type === CONSTANT.DRAWER_TYPE.VIEW) {
          setViewSkillAssessmentDrawer(true);
          dispatch(setAssessmentResultLoading([false, data.skill_id, resultName]));
        }
      })
      .catch((error: any) => error);
    dispatch(fetchCertificationsList()).catch((error: any) => error);
    dispatch(fetchEducationLevelsList()).catch((error: any) => error);
  };


  const getExamDetails = (data: any, type: string) => {
    const resultName = "View User Exam Details";
    console.log('exam details', data);
    if (type === CONSTANT.DRAWER_TYPE.VIEW) {
      dispatch(setAssessmentResultLoading([true, data.id, resultName]));
    }
    dispatch(fetchAllIndustryExamDetails(data.id))
      .then(() => {
        if (type === CONSTANT.DRAWER_TYPE.VIEW) {
          setViewAllExamDrawer(true);
          dispatch(setAssessmentResultLoading([false, data.id, resultName]));
        }
      })
      .catch((error: any) => error);
    dispatch(details(data.id))
  };


  const getChangePasswordDetails = (data: any) => {
    dispatch(setChangePasswordDetails(data));
    setIsChangePasswordVisible(true);
  };

  return (
    <>
      <ToolBar breadcrumbs={UserBreadcrumb}>
        <CreateButton
          action={() => setIsImportVisible(true)}
          permissionKey={`${moduleInfo.permissionKeyPrefix}_INVITE_IMPORT`}
          name="Import"
        />
        {userDetail && userDetail.role_id == CUSTOMER_ROLE ?
          <>
            <CreateButton
              action={() => setIsInviteVisible(true)}
              permissionKey={`${moduleInfo.permissionKeyPrefix}_INVITE`}
              name="Invite"
            />
          </>
          :
          <CreateButton
            action={() => setIsCreateVisible(true)}
            permissionKey={`${moduleInfo.permissionKeyPrefix}_CREATE`}
          />
        }
        <RecordPerPage
          perPage={perPage}
          onChange={(perPageSize: number) => {
            dispatch(setPerPage(perPageSize));
          }}
        />
      </ToolBar>
      <ContentBox>
        <Listing
          moduleInfo={moduleInfo}

          handleExamDetailsClick={(data: any) => {
            getExamDetails(data, CONSTANT.DRAWER_TYPE.VIEW);

          }}
          handleViewClick={(data: any) => {
            getDetails(data, CONSTANT.DRAWER_TYPE.VIEW);
          }}
          handleEditClick={(data: any) => {
            getDetails(data, CONSTANT.DRAWER_TYPE.EDIT);
          }}
          handleDeleteClick={setDeleteValue}
          handleChangePassword={(data: any) => {
            getChangePasswordDetails(data)
          }}
        />

        <ViewDrawer
          titleName={moduleInfo.title}
          open={viewDrawer}
          close={() => dispatch(setDetails(null)) && setViewDrawer(false)}
        />
        <ViewAllExamDetails
          moduleInfo={moduleInfo}
          handleViewInterestAssessmentClick={(data: any) => {
            getInterestAssessmentDetails(data, CONSTANT.DRAWER_TYPE.VIEW);
          }}
          handleViewSkillAssessmentClick={(data: any) => {
            getSkillAssessmentDetails(data, CONSTANT.DRAWER_TYPE.VIEW);
          }}
          handleViewAssessmentResultClick={(data: any) => {
            getAssessmentResultDetails(data, CONSTANT.DRAWER_TYPE.VIEW);
          }}

          titleName={'Industry Wise User Exam Details'}
          open={viewAllExamDrawer}
          close={() => setViewAllExamDrawer(false)}
        />
        <ViewInterestAssessmentDrawer
          titleName={"User Wise Interest Discovery Result"}
          open={viewInterestAssessmentDrawer}
          close={() => setViewInterestAssessmentDrawer(false)}
        />
        <ViewSkillAssessmentDrawer
          titleName={"User Wise Skill Portrait Result"}
          open={viewSkillAssessmentDrawer}
          close={() => setViewSkillAssessmentDrawer(false)}
        />
        <ChangePasswordDrawer
          titleName={"Change Password"}
          open={isChangePasswordVisible}
          close={() => setIsChangePasswordVisible(false)}
        />
        <ViewAssessmentResultDrawer
          titleName={"User Wise Career Compass Result"}
          open={viewAssessmentResultDrawer}
          close={() => setViewAssessmentResultDrawer(false)}
        />
        <EditComponent
          titleName={moduleInfo.title}
          open={editDrawer}
          close={() => dispatch(setDetails(null)) && setEditDrawer(false)}
        />
        <DeleteModal
          title={moduleInfo.title}
          deleteValues={deleteValue}
          callApi={deleteRecord}
          close={() => setDeleteValue(null)}
        />
        {userDetail && userDetail.role_id == CUSTOMER_ROLE ?
          <>
            <InviteComponent
              titleName={moduleInfo.title}
              open={isInviteVisible}
              close={() => setIsInviteVisible(false)}
            />

          </>

          :
          <AddComponent
            titleName={moduleInfo.title}
            open={isCreateVisible}
            close={() => setIsCreateVisible(false)}
          />
        }
        <ImportComponent
          titleName={moduleInfo.title}
          open={isImportVisible}
          close={() => setIsImportVisible(false)}
        />


      </ContentBox>
    </>
  );
};

export default UserManagement;
